import { MutationTree } from 'vuex';
import { SubscriptionStateI, IcsSubscriptionI } from './state';

export const mutations: MutationTree<SubscriptionStateI> = {
  setLoading(state, loading: boolean) {
    state.loading = loading;
  },

  setError(state, error: string | null) {
    state.error = error;
  },

  setSubscriptions(state, subscriptions: IcsSubscriptionI[]) {
    state.subscriptions = subscriptions;
  },

  addSubscription(state, subscription: IcsSubscriptionI) {
    state.subscriptions.push(subscription);
  },

  updateSubscription(
    state,
    { id, updates }: { id: string; updates: Partial<IcsSubscriptionI> },
  ) {
    const index = state.subscriptions.findIndex((s) => s.id === id);
    if (index !== -1) {
      state.subscriptions[index] = {
        ...state.subscriptions[index],
        ...updates,
      };
    }
  },

  removeSubscription(state, id: string) {
    state.subscriptions = state.subscriptions.filter((s) => s.id !== id);
  },

  clearError(state) {
    state.error = null;
  },
};
